import React from "react";
import { Link } from "react-router-dom";
import { useThemeAsset } from "@/Hooks/useThemeAsset";

const LinkIcon: React.FC = () => {
  const { iconCategories, icon } = useThemeAsset();

  return (
    <div className="mt-8 px-4">
      <div className="grid grid-cols-5 gap-5">
        {iconCategories.map((category, index) =>
          category.link ? (
            <a
              href={category.link}
              key={index}
              className="flex flex-col items-center justify-center whitespace-nowrap"
              target="_blank"
              rel="noopener noreferrer"
            >
              {category.label !== "WE:U" ? (
                <img src={icon(category.image)} width={138} height={138} alt={category.label} />
              ) : (
                <div className="border rounded-full border-blue-300">
                  <img src={icon(category.image)} alt={category.label} />
                </div>
              )}
              <span className="text-sm mt-2 text-[#666666]">
                {category.label}
              </span>
            </a>
          ) : (
            <Link
              to={`/detailcategory/${encodeURIComponent(category.label)}`}
              key={index}
              className="flex flex-col items-center justify-center"
            >
              <img src={icon(category.image)} alt={category.label} />

              <span className="text-sm mt-2 text-[#666666]">
                {category.label}
              </span>
            </Link>
          )
        )}
      </div>
    </div>
  );
};

export default LinkIcon;
